(function () {
    'use strict';

    angular.module("imApp").factory("choicePossRuleService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1176,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1177,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 1186,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
